var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6021 0.449128L6.5 5.55123L1.3979 0.449128C1.135 0.186228 0.710076 0.186228 0.447175 0.449128C0.184275 0.712029 0.184275 1.13695 0.447175 1.39985L5.54928 6.50195L0.447175 11.601C0.184275 11.8639 0.184275 12.2888 0.447175 12.5517C0.710076 12.8146 1.135 12.8146 1.3979 12.5517L6.5 7.44962L11.6021 12.5517C11.865 12.8146 12.2899 12.8146 12.5528 12.5517C12.8157 12.2888 12.8157 11.8639 12.5528 11.601L7.45072 6.50195L12.5528 1.39985C12.8157 1.13695 12.8157 0.712029 12.5528 0.449128C12.2899 0.186228 11.865 0.186228 11.6021 0.449128Z",
    fill: "#2E3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.6831655b3e83328f90d72da2f8f8e519.svg";
export { ForwardRef as ReactComponent };